export default __webpack_public_path__ + "static/media/person_add_share.23dfe2a6.svg";